export default "__VITE_ASSET__DfWBXXRM__"